/**
 * Vite エントリーポイント
 * すべてのJavaScriptファイルとCSSファイルを統合
 */

// CSS の読み込み
import './input.css'

// JavaScript モジュールの読み込み
import './js/animations.js'
import './js/case-filter.js'
import './js/script.js'
import './js/toc.js'
import './js/typing.js'

// WordPress条件分岐の処理
document.addEventListener('DOMContentLoaded', function() {
  // 施工事例フィルター用のスクリプト（条件分岐）
  if (document.body.classList.contains('post-type-archive-case')) {
    // case-filter.js の処理は既に読み込まれている
  }

  // タイピングアニメーション用のスクリプト（条件分岐）
  if (document.body.classList.contains('home')) {
    // typing.js の処理は既に読み込まれている
  }

  // TOCスクリプト（条件分岐）
  if (document.body.classList.contains('single-contents')) {
    // toc.js の処理は既に読み込まれている
  }
})

// 開発環境でのコンソールログ
if (import.meta.env.DEV) {
  // console.log('🚀 Vite development server is running')
  // console.log('📦 All modules loaded successfully')
}
